<script setup lang="ts">
import type { Schemas } from "#shopware";
import { useUrlResolver } from "#imports";
import { RouterLink } from "vue-router";
import {
  buildUrlPrefix,
  getCategoryRoute,
  getTranslatedProperty,
  urlIsAbsolute,
} from "@shopware/helpers";
import { computed } from "vue";

interface Props {
  navigationElement: Schemas["Category"];
  isActive?: boolean;
  isHighlighted?: boolean;
}

const props = defineProps<Props>();
const { getUrlPrefix } = useUrlResolver();
const url = computed(() => {
  return buildUrlPrefix(
    getCategoryRoute(props.navigationElement),
    getUrlPrefix()
  );
});
</script>

<template>
  <div>
    <RouterLink
      v-if="!urlIsAbsolute(url.path)"
      :to="url"
      :class="[
        props.isHighlighted ? 'font-bold' : 'font-normal',
        props.isActive ? 'text-indigo-600' : 'text-gray-900',
      ]"
    >
      <input type="checkbox" />
      <label class="ml-2"
        >{{ getTranslatedProperty(navigationElement, "name") }}
        <!-- <span class="text-skin-light">(12)</span> -->
      </label>
    </RouterLink>
    <a
      v-else
      :href="url.path"
      :class="[
        props.isHighlighted ? 'font-bold' : 'font-normal',
        props.isActive ? 'text-indigo-600' : 'text-gray-900',
      ]"
      :target="
        navigationElement.externalLink || navigationElement.linkNewTab
          ? '_blank'
          : ''
      "
      ><span>{{ getTranslatedProperty(navigationElement, "name") }}</span></a
    >
  </div>
</template>
